export const BtnVariant = ['solid', 'outlined', 'subtle', 'link'] as const;
export const BtnColor = ['primary', 'gray', 'error', 'tertiary-gray'] as const;
export const BtnSize = ['sm', 'md', 'lg', 'xl', '2xl'] as const;
